import { useAtom } from "jotai";
import { navbarAtom } from "../../lib/atoms";
import clsx from "clsx";
import MenuLink from "./MenuLink";
import {
  Book,
  Euro,
  FileIcon,
  FileMinus,
  LogOut,
  MailQuestion,
  ShoppingBag,
  SquarePen,
  User,
  Users2,
  Video,
} from "lucide-react";
import { useAuthStatus } from "../../lib/stores/auth-store";
import { useLogout } from "../../lib/hooks/useLogout";

const SectionLabel = ({ children }: { children: React.ReactNode }) => (
  <p className="px-3 pb-1 pt-2 text-[11px] font-semibold uppercase tracking-wider text-slate-400">
    {children}
  </p>
);

const Navbar = () => {
  const [navbarOpen, setNavbar] = useAtom(navbarAtom);
  const signOut = useAuthStatus((state) => state.logout);
  const { mutateAsync: logout } = useLogout();

  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      signOut();
      setNavbar(false);
    }
  };

  return (
    <div
      className={clsx(
        "fixed z-50 mt-14 flex h-screen w-screen flex-col gap-0.5 overflow-y-auto border-r border-slate-200 bg-white px-3 pb-28 pt-4 transition-all duration-200 md:mt-20 md:w-56",
        { "left-0": navbarOpen, "-left-full md:left-0": !navbarOpen }
      )}
    >
      <SectionLabel>Mon adhésion</SectionLabel>
      <MenuLink to='/' icon={<Book className='h-full w-full' />} label='Abonnement' />
      <MenuLink to='/syndicat' icon={<Users2 className='h-full w-full' />} label='Syndicat' />
      <MenuLink to='/attestations' icon={<FileMinus className='h-full w-full' />} label='Attestations' />
      <MenuLink to='/factures' icon={<Euro className='h-full w-full' />} label='Factures' />

      <SectionLabel>Services</SectionLabel>
      <MenuLink to='/revues-numeriques' icon={<FileIcon className='h-full w-full' />} label='Revue numérique' />
      <MenuLink to='/boutique' icon={<ShoppingBag className='h-full w-full' />} label='Boutique' />
      <MenuLink to='/petites-annonces' icon={<SquarePen className='h-full w-full' />} label='Petites annonces' />
      <MenuLink to='/webinaires' icon={<Video className='h-full w-full' />} label='Webinaires' />

      <SectionLabel>Aide</SectionLabel>
      <MenuLink to='/aide' icon={<MailQuestion className='h-full w-full' />} label='Nous contacter' />

      {/* Section mobile : compte + déconnexion, ancrée en bas */}
      <div className='mt-auto block border-t border-slate-100 pt-3 md:hidden'>
        <MenuLink to='/coordonnees' icon={<User className='h-full w-full' />} label='Mes coordonnées' />
        <button
          onClick={handleLogout}
          className='mt-1 flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium text-red-500 transition-colors duration-200 hover:bg-red-50'
        >
          <span className='flex h-5 w-5 shrink-0 items-center justify-center'>
            <LogOut className='h-full w-full' />
          </span>
          Déconnexion
        </button>
      </div>
    </div>
  );
};

export default Navbar;
